import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import noticeInfo from '@/components/noticeInfo'
import course from '@/components/course'


Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'index',
            component: index,
            meta: {
                title: '“简意杯”微课竞赛',
                keepAlive: true // 需要缓存
            }
        },
        {
            path: '/noticeInfo',
            name: 'noticeInfo',
            meta: {
                keepAlive: false // 需要缓存
            },
            component: noticeInfo
        },
        {
            path: '/course',
            name: 'course',
            meta: {
                keepAlive: false // 需要缓存
            },
            component: course
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js